import PropTypes from "prop-types";
import { ListItem } from "components/ui";
import useTranslate from "hooks/use-translate-language";
import { formatAddress, formatDate, formatPhone } from "utils/misc";

const Insurance = ({ insurances }) => {
  const translate = useTranslate();
  return (
    <div className="profile-panel">
      <h4 className="profile-panel-header">{translate("insurances")}</h4>
      <div
        className="profile-content"
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridGap: 5 }}
      >
        {insurances.map((x, i) => (
          <div key={i}>
            
            <h3>{i == 0 ? translate("primaryInsurance") : translate("secondaryInsurance")}</h3>
            <div style={{ paddingLeft: 10 }}>
              <ListItem label={translate("insurance")} value={x.insurance_company_name ?? "-"} />
              <ListItem label={translate("groupNumber")} value={x.group ?? "-"} />
              <ListItem label={translate("policyNumber")} value={x.plan_no ?? "-"} />
              <ListItem label={translate("insurancePhoneNumber")} value={x.insurance_phone ? formatPhone(x.insurance_phone): "-"} />
              <ListItem
                label={translate("insuranceAddress")}
                value={formatAddress(x.insurance_address)}
              />
              <ListItem
                label={translate("policyStartDate")}
                value={x.policy_start_date ? formatDate(x.policy_start_date) : "-"}
              />
              <ListItem
                label={translate("policyEndDate")}
                value={ x.policy_end_date ?  formatDate(x.policy_end_date) :  "-"}
              />
              <ListItem
                label={translate("guarantorName")}
                value={x.guarantor_name ?? "-"}
              />
              <ListItem
                label={translate("guarantorRelation")}
                value={x.guarantor_relation ?? "-"}
              />
              <ListItem
                label={translate("guarantorDob")}
                value={x.guarantor_dob ? formatDate(x.guarantor_dob) : "-"}
              />
               
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Insurance.propTypes = {
  insurances: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Insurance;
